// Zip the STRUCTURED item onto each blob-parsed assessment line, by POSITION.
//
// The spine's lines come from parsing `parsed_items`; the fields the page needs per
// item live on the structured `deal.items` (projectQuoteItem) — above all
// `quote_item_id`, the address every per-item read and write travels by.
//
// Position-zip is safe HERE and only here because the blob is GENERATED from the
// same live items in idx order (itemsToParsedItems): one line per item, dead items
// excluded from both sides. The item's `idx` is deliberately NOT carried — a stored
// index is not an address this page should hold, and holding one is what let a read
// key off a row position and land on the neighbour.
//
// Guarded: any length mismatch means that assumption broke somewhere, and the merge
// yields NO structured fields rather than shifted ones. An "Engine added" badge on a
// line the customer typed is worse than no badge, and an edit that lands on the wrong
// item is worse than one that refuses — with no `quote_item_id` the page blocks that
// line's actions and says why.
const MERGED_FIELDS = [
    'quote_item_id', 'source', 'display_name', 'brand', 'model', 'colour', 'declared_name', 'is_pair',
    // The warehouse's OP suggestion (spec 20261019_op-quote-routing), shown under the SP/BP.
    'warehouse_sp_cents', 'warehouse_bp_cents',
];

export function mergeStructuredItems(parsedLines, structuredItems) {
    const lines = parsedLines || [];
    const structured = structuredItems || [];
    if (lines.length !== structured.length) return lines;
    return lines.map((line, i) => {
        const merged = { ...line };
        for (const field of MERGED_FIELDS) merged[field] = structured[i]?.[field] ?? null;
        return merged;
    });
}
